import { Navigate, useLocation } from "react-router-dom";

import { PAGE_FEATURE_FLAGS, PAGE_PERMISSIONS } from "../../config/permissions";
import { useAuthenticated, useUserGroups } from "../../hooks/authHooks";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { ProtectedRouteProps } from "../../types/auth.types";
import LoadingSpinner from "../layout/LoadingSpinner";

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, pageId }) => {
  const { isAuthenticated, loading } = useAuthenticated();
  const userGroups = useUserGroups();
  const flags = useFeatureFlags();
  const location = useLocation();

  if (loading) return <LoadingSpinner />;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (pageId) {
    const featureFlag = PAGE_FEATURE_FLAGS[pageId];
    if (featureFlag && !flags[featureFlag]) return <Navigate to="/dashboard" replace />;

    const allowed = PAGE_PERMISSIONS[pageId] ?? [];
    const hasAccess =
      allowed.length === 0 ||
      allowed.some((g) => userGroups.includes(g)) ||
      userGroups.includes("GlobalAdmin");
    if (!hasAccess) return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
